export const simples = (valor) => {

   if (valor.length < 1) return { value: false, mess: "campo obrigatório não preenchido" }
   
   return true
    
};